<template>
  <div>
  </div>
</template>
<script>
import {SearchApi} from "../Api/SearchApi";

export default {
  data() {
    return {
      userSlugs: {}
    }
  },
  props: ['items'],

  watch: {
    items: {
      handler(newVal) {
        this.processItems(newVal)
      },
      immediate: true
    }
  },

  methods: {
    async processItems(items) {
      if (!items || !items.length) {
        return
      }

      const truncatedItemUuids = [...new Set(items.map(item => item.user_uuid))]

      const missingUuids = truncatedItemUuids.filter(uuid => !this.userSlugs[uuid])

      if (missingUuids.length) {
        try {
          const uuids = missingUuids.map(this.algoliaUuidToRegularUuid)

          const userNames = await SearchApi.getUserNames(uuids)

          const truncated = Object.keys(userNames).reduce((acc, key) => {
            const truncatedUuid = key.replace(/-/g, '')
            acc[truncatedUuid] = userNames[key]
            return acc
          }, {})

          this.userSlugs = { ...this.userSlugs, ...truncated}
          this.$emit('userSlugs', this.userSlugs)
        } catch (e) {
          console.error(e)
        }
      }
    },

    algoliaUuidToRegularUuid(truncatedUuid) {
      return truncatedUuid.replace(
        /([a-f0-9]{8})([a-f0-9]{4})([a-f0-9]{4})([a-f0-9]{4})([a-f0-9]{12})/,
        '$1$2-$3$4-$5'
      )
    }
  },


}
</script>